/**
 * 垂直拖拽动画
 */
import fvAnimation from "./fvAnimation"
export default class fvVerticalDrag extends fvAnimation {
    constructor(shape){
        super(shape,"fvVerticalDrag");
        this.dragingFlag = 0;
        this.orgShapePt = {
            x:0,
            y:0
        };

        this.shapeY = 0,

        this.orgPt = {
            x:0,
            y:0
        };
        this.expFunction = AsyncFunction('curData',this.expression + "=" + 'curData');
        this.min = AsyncFunction("return " + this.min);
        this.max = AsyncFunction("return " + this.max);
        this.minMoveToValue = AsyncFunction("return " + this.minMoveToValue);
        this.maxMoveToValue = AsyncFunction("return " + this.maxMoveToValue);
        this.orgShapePt.y = this.shape.y;
    }

    run(event,value){
        if(value == false) return;
        if(!this.shape.mouseState){
            this.dragingFlag = 0;
            return;
        }
        if(this.shape.mouseState&& event.button == 0 || event.button == -1) {
            this.action(event,value);
        }else if(event.touches){
            this.touchAction(event,value);
        }
        super.run();
    }

    async action(event,value){
        var minValue = await this.executionScript(this.min);
        var maxValue = await this.executionScript(this.max);
        var minMoveToValueValue = await this.executionScript(this.minMoveToValue);
        var maxMoveToValueValue = await this.executionScript(this.maxMoveToValue);
        if("down" == this.getEventType(event.type)){
            this.shapeY = this.shape.y;
            this.orgPt.y = event.offsetY;
            this.dragingFlag = 1;
        }
        if("up" == this.getEventType(event.type) ||"dragend" == event.type){
            this.dragingFlag = 0;
        }
        if("move" == this.getEventType(event.type)){
            if(!this.shape.system){
                this.shapeY = this.shape.y;
            }
            if(this.dragingFlag == 1){
                var Y = event.offsetY - this.orgPt.y;
                var curY = this.shapeY + Y;
                if(curY < parseFloat(this.orgShapePt.y) - maxMoveToValueValue)
                    curY = parseFloat(this.orgShapePt.y) - maxMoveToValueValue;

                if(curY > parseFloat(this.orgShapePt.y) - minMoveToValueValue)
                    curY = parseFloat(this.orgShapePt.y) - minMoveToValueValue;

                var curData = parseFloat(minValue) + (maxValue - minValue)*(parseFloat(this.orgShapePt.y) - curY)/(maxMoveToValueValue - minMoveToValueValue);
                this.expFunction(curData);
            }
        }
    }

    touchAction(event,value){
        if("down" === this.getEventType(event.type)){
            this.shapeY = this.shape.y;
            this.orgPt.y = event.pageY;
            this.dragingFlag = 1;
            console.log("drag  begin");
        }else if("up" === this.getEventType(event.type) ||"dragend" == event.type){
            console.log("drag  end");
            this.dragingFlag = 0;
        }else if("move" === this.getEventType(event.type)){
            if(this.dragingFlag == 1){
                console.log("draging");
                var Y = event.pageY - this.orgPt.y;
                var curY = this.shapeY + Y;

                if(curY < parseFloat(this.orgShapePt.y) - maxMoveToValueValue)
                    curY = parseFloat(this.orgShapePt.y) - maxMoveToValueValue;

                if(curY > parseFloat(this.orgShapePt.y) - minMoveToValueValue)
                    curY = parseFloat(this.orgShapePt.y) - minMoveToValueValue;

                var curData = parseFloat(minValue) + (maxValue - minValue)*(parseFloat(this.orgShapePt.y) - curY)/(maxMoveToValueValue - minMoveToValueValue);
                this.expFunction(curData);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvVerticalDrag.js